const staff = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {
    setToken(state, data) {
      state.token = data;
    }
  },
  actions: {
    async updateStaffAccountStatus({ rootState }, params) {
      const data = await rootState.http("/staff/updateStaffAccountStatus", params);
      return data;
    },
    async getStaffList({ rootState }, params = {}) {
      const data = await rootState.http("/staff/queryStaffAccountList", params);
      return data;
    },
    async createStaff({ rootState }, params = {}) {
      const data = await rootState.http("/staff/createStaffAccount", params);
      return data;
    },
    async updateStaff({ rootState }, params = {}) {
      const data = await rootState.http("/staff/updateStaffAccount", params);
      return data;
    },
    async getStaffDetail({ rootState }, params = {}) {
      const data = await rootState.http("/staff/getStaffAccount", params, {
        errorMessage: false
      });
      return data;
    },
    async getTechnicianStaffList({ rootState }, params = {}) {
      const data = await rootState.http("/staff/queryTechnicianList", params, {
        errorMessage: false
      });
      return data;
    },
    async resetStaffPassword({ rootState }, params = {}) {
      const data = await rootState.http("/staff/admin/resetPassword", params, {
        errorMessage: false
      });
      return data;
    }
  }
};

export default staff;
